export class User {
    email: string = "";
    phone: string = "";
    name: string = "";
    avatar: string | null = null;

    static createFromObj(obj: Object): User {
        const user = new User(obj.id, obj.login);
        user.email = obj.email;
        user.phone = obj.phone;
        user.name = obj.name ?? "";
        user.avatar = obj.avatar ?? null;

        return user;
    }

    constructor(public readonly id: number, public login: string) {
    }

}
